import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import './help-center.css';
import OrderArriveWidget from './widgets/orderArrive';
import PlaceOrderWidget from './widgets/placeOrder';
import ProblemOrderWidget from './widgets/problemOrder';
import ScanHistoryWidget from './widgets/scanHistory';
import CancelWidget from './widgets/cancel';
import ChangeShipMethodWidget from './widgets/changeShipMethod';
import PlaceCrosOrderWidget from './widgets/placeCrosOrder';
import CreateMixOrderWidget from './widgets/createMixOrder';
import GrantAccessPrositeWidget from './widgets/grantAccessProsite';
import { ISession } from '../../../models/pro-sites';
import { KR, DE } from '../../common/constants';
import { getContactUsLink } from '../../../hooks/contactus-hook';
interface IHelpCenterProps {
    session: ISession | null;
}
export const HelpCenter = ({ session }: IHelpCenterProps) => {
    const [, setIsShowing] = useState(false);
    const [widgets, setWidgets] = useState<{
        cancelWidget: boolean;
        scanHistoryWidget: boolean;
        orderArriveWidget: boolean;
        changeShipMethodWidget: boolean;
        problemOrderWidget: boolean;
        placeOrderWidget: boolean;
        placeCrosOrderWidget: boolean;
        createMixOrderWidget: boolean;
        grantAccessPrositeWidget: boolean;
    }>({
        cancelWidget: false,
        scanHistoryWidget: false,
        orderArriveWidget: false,
        changeShipMethodWidget: false,
        problemOrderWidget: false,
        placeOrderWidget: false,
        placeCrosOrderWidget: false,
        createMixOrderWidget: false,
        grantAccessPrositeWidget: false,
    });
    const showWidget = (widget: string) => {
        setWidgets({
            ...widgets,
            [widget]: true,
        });
        setIsShowing(true);
    };
    const hideWidget = (widget: string) => {
        setWidgets({
            ...widgets,
            [widget]: false,
        });
        setIsShowing(false);
    };
    useEffect(() => {
        window.scroll(0, 0);
    }, []);
    /*
    useChatWidget();
    */
    return (
        <>
            <div className="masthead">
                <header>
                    <div>
                        <h1 className="h1 white-text">
                            <FormattedMessage
                                id="Help_Center"
                                defaultMessage="Help Center"
                            />
                        </h1>
                    </div>
                </header>
            </div>
            <main>
                <div className="main-body">
                    {widgets.cancelWidget && (
                        <CancelWidget
                            onClose={() => {
                                hideWidget('cancelWidget');
                            }}
                        />
                    )}
                    {widgets.scanHistoryWidget && (
                        <ScanHistoryWidget
                            onClose={() => {
                                hideWidget('scanHistoryWidget');
                            }}
                        />
                    )}
                    {widgets.problemOrderWidget && (
                        <ProblemOrderWidget
                            onClose={() => {
                                hideWidget('problemOrderWidget');
                            }}
                        />
                    )}
                    {widgets.changeShipMethodWidget && (
                        <ChangeShipMethodWidget
                            onClose={() => {
                                hideWidget('changeShipMethodWidget');
                            }}
                        />
                    )}
                    {widgets.orderArriveWidget && (
                        <OrderArriveWidget
                            onClose={() => {
                                hideWidget('orderArriveWidget');
                            }}
                        />
                    )}
                    {widgets.placeOrderWidget && (
                        <PlaceOrderWidget
                            onClose={() => {
                                hideWidget('placeOrderWidget');
                            }}
                        />
                    )}
                    {widgets.placeCrosOrderWidget && (
                        <PlaceCrosOrderWidget
                            onClose={() => {
                                hideWidget('placeCrosOrderWidget');
                            }}
                        />
                    )}
                    {widgets.createMixOrderWidget && (
                        <CreateMixOrderWidget
                            onClose={() => {
                                hideWidget('createMixOrderWidget');
                            }}
                        />
                    )}
                    {widgets.grantAccessPrositeWidget && (
                        <GrantAccessPrositeWidget
                            onClose={() => {
                                hideWidget('grantAccessPrositeWidget');
                            }}
                        />
                    )}
                    {!Object.values(widgets).some((item) => item === true) && (
                        <>
                            <h2>
                                <FormattedMessage
                                    id="eStore_How_to"
                                    defaultMessage="eStore How to..."
                                />
                            </h2>
                            <div className="box-collage">
                                <div
                                    className="boxes"
                                    onClick={() => {
                                        showWidget('orderArriveWidget');
                                    }}
                                >
                                    <div className="video-heading-icon">
                                        <img
                                            src="/estore/images/help_center/bell_arrive.png"
                                            alt=""
                                        />
                                        <p>
                                            <FormattedMessage
                                                id="When_will_it_arrive"
                                                defaultMessage="When will my order arrive?"
                                            />
                                        </p>
                                    </div>
                                    <div className="video-tutorial">
                                        <img
                                            src="/estore/images/help_center/video_icon.png"
                                            alt=""
                                        />
                                        <p>
                                            <FormattedMessage
                                                id="Video_tutorial"
                                                defaultMessage="Video Tutorial"
                                            />
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className="boxes"
                                    onClick={() => {
                                        showWidget('placeOrderWidget');
                                    }}
                                >
                                    <div className="video-heading-icon">
                                        <img
                                            src="/estore/images/help_center/place_an_order.png"
                                            alt=""
                                        />
                                        <p>
                                            <FormattedMessage
                                                id="I_need_to_place_an_order"
                                                defaultMessage="I need to place an order"
                                            />
                                        </p>
                                    </div>
                                    <div className="video-tutorial">
                                        <img
                                            src="/estore/images/help_center/video_icon.png"
                                            alt=""
                                        />
                                        <p>
                                            <FormattedMessage
                                                id="Video_tutorial"
                                                defaultMessage="Video Tutorial"
                                            />
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className="boxes"
                                    onClick={() => {
                                        showWidget('problemOrderWidget');
                                    }}
                                >
                                    <div className="video-heading-icon">
                                        <img
                                            src="/estore/images/help_center/lines_report.png"
                                            alt=""
                                        />
                                        <p>
                                            <FormattedMessage
                                                id="I_need_to_report_a_problem_with_my_order"
                                                defaultMessage="I need to report a problem with my order"
                                            />
                                        </p>
                                    </div>
                                    <div className="video-tutorial">
                                        <img
                                            src="/estore/images/help_center/video_icon.png"
                                            alt=""
                                        />
                                        <p>
                                            <FormattedMessage
                                                id="Video_tutorial"
                                                defaultMessage="Video Tutorial"
                                            />
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className="boxes"
                                    onClick={() => {
                                        showWidget('scanHistoryWidget');
                                    }}
                                >
                                    <div className="video-heading-icon">
                                        <img
                                            src="/estore/images/help_center/columns_history.png"
                                            alt=""
                                        />
                                        <p>
                                            <FormattedMessage
                                                id="I_need_to_view_my_scan_history"
                                                defaultMessage="I need to view my scan history"
                                            />
                                        </p>
                                    </div>
                                </div>
                                {!['KR', 'CA', 'DE'].includes(
                                    session!.country
                                ) && (
                                    <div
                                        className="boxes"
                                        onClick={() => {
                                            showWidget(
                                                'changeShipMethodWidget'
                                            );
                                        }}
                                    >
                                        <div className="video-heading-icon">
                                            <img
                                                src="/estore/images/help_center/pencil_ship.png"
                                                alt=""
                                            />
                                            <p>
                                                <FormattedMessage
                                                    id="I_need_to_change_my_shipping_method_on_an_open_order"
                                                    defaultMessage="I need to change my shipping method on
                                        an open order"
                                                />
                                            </p>
                                        </div>
                                        <div className="video-tutorial">
                                            <img
                                                src="/estore/images/help_center/video_icon.png"
                                                alt=""
                                            />
                                            <p>
                                                <FormattedMessage
                                                    id="Video_tutorial"
                                                    defaultMessage="Video Tutorial"
                                                />
                                            </p>
                                        </div>
                                    </div>
                                )}
                                <div
                                    className="boxes"
                                    onClick={() => {
                                        showWidget('cancelWidget');
                                    }}
                                >
                                    <div className="video-heading-icon">
                                        <img
                                            src="/estore/images/help_center/calendar_cancel.png"
                                            alt=""
                                        />
                                        <p>
                                            <FormattedMessage
                                                id="I_need_to_cancel_an_order"
                                                defaultMessage="I need to cancel an order"
                                            />
                                        </p>
                                    </div>
                                    <div className="video-tutorial">
                                        <img
                                            src="/estore/images/help_center/video_icon.png"
                                            alt=""
                                        />
                                        <p>
                                            <FormattedMessage
                                                id="Video_tutorial"
                                                defaultMessage="Video Tutorial"
                                            />
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className="boxes"
                                    onClick={() => {
                                        showWidget('placeCrosOrderWidget');
                                    }}
                                >
                                    <div className="video-heading-icon">
                                        <img
                                            src="/estore/images/help_center/crosOrder.png"
                                            alt=""
                                        />
                                        <p>
                                            <FormattedMessage
                                                id="I_need_to_place_a_CROS_BiCROS_order"
                                                defaultMessage="Place a CROS/biCROS order"
                                            />
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className="boxes"
                                    onClick={() => {
                                        showWidget('createMixOrderWidget');
                                    }}
                                >
                                    <div className="video-heading-icon">
                                        <img
                                            src="/estore/images/help_center/order_custom_mold_with_hearing_aid.png"
                                            alt=""
                                        />
                                        <p>
                                            <FormattedMessage
                                                id="I_need_to_order_a_custom_mold_with_hearing_aid"
                                                defaultMessage="Order custom ear mold"
                                            />
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className="boxes"
                                    onClick={() => {
                                        showWidget('grantAccessPrositeWidget');
                                    }}
                                >
                                    <div className="video-heading-icon">
                                        <img
                                            src="/estore/images/help_center/grantAccess.png"
                                            alt=""
                                        />
                                        <p>
                                            <FormattedMessage
                                                id="I_need_to_grant_employee_access_to_Prosite"
                                                defaultMessage="Give employee ProSite access"
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <div className="main-footer">
                    <div className="col-sm-8">
                        <h2 className="blue-text">
                            <FormattedMessage
                                id="Other_Questions"
                                defaultMessage="Other Questions"
                            />
                        </h2>
                        <div
                            id="myAccordion"
                            className="accordion-qs myAccordion"
                        >
                            <div className="card">
                                <div className="card-header" id="headingOne">
                                    <h5 className="mb-0">
                                        <button
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#collapseOne"
                                            aria-expanded="false"
                                            aria-controls="collapseOne"
                                        >
                                            <FormattedMessage
                                                id="What_is_the_return_policy"
                                                defaultMessage="What is the return policy?"
                                            />
                                        </button>
                                    </h5>
                                </div>
                                <div
                                    id="collapseOne"
                                    className="collapse"
                                    aria-labelledby="headingOne"
                                    data-parent="#myAccordion"
                                >
                                    {session!.country === DE ? (
                                        <div className="card-body">
                                            <FormattedMessage
                                                id="Products_may_be_returned"
                                                defaultMessage="Products may be returned for full credit
                                            to Customer's account within 90 days
                                            from the date of invoice unless
                                            otherwise stated on invoice. Refunds
                                            will be credited to the Customer
                                            account. Shipping and handling fees do
                                            not get credited."
                                            />
                                        </div>
                                    ) : (
                                        <div className="card-body">
                                            <FormattedMessage
                                                id="Products_may_be_returned_for_full_credit"
                                                defaultMessage="Products may be returned for full credit
                                            to Customer's account within 90 days
                                            from the date of invoice unless
                                            otherwise stated on invoice. Refunds
                                            will be credited to the Customer
                                            account. Shipping and handling fees do
                                            not get credited. See full return policy"
                                            />{' '}
                                            <a
                                                href="/my-account/policies"
                                                aria-label="Click here for Return Policy"
                                            >
                                                <FormattedMessage
                                                    id="Here"
                                                    defaultMessage="here"
                                                />
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header" id="headingTwo">
                                    <h5 className="mb-0">
                                        <button
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#collapseTwo"
                                            aria-expanded="false"
                                            aria-controls="collapseTwo"
                                        >
                                            <FormattedMessage
                                                id="When_will_I_know_if_my_order_has_been_received"
                                                defaultMessage="When will I know if my order has
                                            been received?"
                                            />
                                        </button>
                                    </h5>
                                </div>
                                <div
                                    id="collapseTwo"
                                    className="collapse"
                                    aria-labelledby="headingTwo"
                                    data-parent="#myAccordion"
                                >
                                    <div className="card-body">
                                        <p>
                                            <strong>
                                                <FormattedMessage
                                                    id="Order_Confirmation_Email"
                                                    defaultMessage="Order Confirmation Email"
                                                />
                                            </strong>
                                        </p>
                                        <p>
                                            <FormattedMessage
                                                id="We_will_send_you_an_order_ce"
                                                defaultMessage="We will send you an order
                                            confirmation email to verify that
                                            your order has been received. In
                                            this email you can see the date you
                                            placed your order, your Order ID,
                                            the estimated delivery date,
                                            shipping method and address, and
                                            itemized costs."
                                            />
                                        </p>
                                        <p>
                                            <strong>
                                                <FormattedMessage
                                                    id="Pizza_Tracker_Status_Update"
                                                    defaultMessage="Pizza Tracker Status Update"
                                                />
                                            </strong>
                                        </p>
                                        <p>
                                            <FormattedMessage
                                                id="The_order_tracker_on_your_order"
                                                defaultMessage="The order tracker on your order
                                            details page will update to received
                                            status."
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header" id="headingThree">
                                    <h5 className="mb-0">
                                        <button
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#collapseThree"
                                            aria-expanded="false"
                                            aria-controls="collapseThree"
                                        >
                                            <FormattedMessage
                                                id="Can_I_make_changes_to_my_order_after"
                                                defaultMessage="Can I make changes to my order after
                                            I place it?"
                                            />
                                        </button>
                                    </h5>
                                </div>
                                <div
                                    id="collapseThree"
                                    className="collapse"
                                    aria-labelledby="headingThree"
                                    data-parent="#myAccordion"
                                >
                                    <div className="card-body">
                                        <p>
                                            <FormattedMessage
                                                id="Yes"
                                                defaultMessage="{0}, you can make
                                        changes to most orders! Simply go to
                                        the Order Details page of the order
                                        you'd like to update, and choose
                                        from the list of options in the
                                        'Need to make changes to your order'
                                        dropdown. If the option is
                                        unavailable the order has progressed
                                        too far to make any changes on the
                                        order"
                                                values={{
                                                    0: <strong>Yes</strong>,
                                                }}
                                            />
                                            .{' '}
                                            <a href="/prosite/my-account/order-history">
                                                <FormattedMessage
                                                    id="Click_here_to_view_orders"
                                                    defaultMessage="Click here to view orders"
                                                />
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="card">
                                <div className="card-header" id="headingFour">
                                    <h5 className="mb-0">
                                        <button
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#collapseFour"
                                            aria-expanded="false"
                                            aria-controls="collapseFour"
                                        >
                                            <FormattedMessage
                                                id="What_options_do_I_have_for_shipping"
                                                defaultMessage="What options do I have for shipping?"
                                            />
                                        </button>
                                    </h5>
                                </div>
                                <div
                                    id="collapseFour"
                                    className="collapse"
                                    aria-labelledby="headingFour"
                                    data-parent="#myAccordion"
                                >
                                    <div className="card-body">
                                        <p>
                                            <FormattedMessage
                                                id="Shipping_options_will_vary_depending"
                                                defaultMessage="Shipping options will vary depending
                                                on the product type and
                                                availability. Please refer to the
                                                options below:"
                                            />
                                        </p>
                                        <p>
                                            <strong>
                                                <FormattedMessage
                                                    id="Hearing_Aids_Wireless_Accessories_and_Chargers"
                                                    defaultMessage="Hearing Aids, Wireless
                                                Accessories and Chargers"
                                                />
                                            </strong>{' '}
                                            <FormattedMessage
                                                id="delivery_options"
                                                defaultMessage="delivery options:"
                                            />
                                        </p>
                                        <ul className="ordered-list-sec">
                                            <li>
                                                <FormattedMessage
                                                    id="Overnight_Next_Day_Delivery"
                                                    defaultMessage="Overnight, next day delivery"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Second_Day_Air"
                                                    defaultMessage="Second Day Air"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Overnight_Next_Day_Delivery_By_1030"
                                                    defaultMessage="Overnight, next day by 10:30"
                                                />
                                            </li>
                                        </ul>
                                        <p>
                                            <strong>
                                                <FormattedMessage
                                                    id="Earmold_New_Orders_Earmold_Repairs_Earmold_Remakes"
                                                    defaultMessage="Earmold New Orders, Earmold
                                                Repairs, Earmold Remakes"
                                                />
                                            </strong>{' '}
                                            <FormattedMessage
                                                id="delivery_options"
                                                defaultMessage="delivery options:"
                                            />
                                        </p>
                                        <ul className="ordered-list-sec">
                                            <li>
                                                <FormattedMessage
                                                    id="First_Class_Mail_Tracking_1-3days"
                                                    defaultMessage="First Class Mail with Tracking
                                                1-3 Days"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Ground_1-5_days_intransit_dep_on_zone"
                                                    defaultMessage="Ground, 1-5 days in transit
                                                depending on zone"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Overnight_Next_Day_Delivery"
                                                    defaultMessage="Overnight, next day delivery"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Second_Day_Air"
                                                    defaultMessage="Second Day Air"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Overnight_Next_Day_Delivery_By_1030"
                                                    defaultMessage="Overnight, next day by 10:30"
                                                />
                                            </li>
                                        </ul>
                                        <p>
                                            <strong>
                                                <FormattedMessage
                                                    id="Battery_Orders"
                                                    defaultMessage="Battery Orders"
                                                />
                                            </strong>{' '}
                                            <FormattedMessage
                                                id="delivery_options"
                                                defaultMessage="delivery options:"
                                            />
                                        </p>
                                        <ul className="ordered-list-sec">
                                            <li>
                                                <FormattedMessage
                                                    id="Ground_1-5_days_intransit_dep_on_zone"
                                                    defaultMessage="Ground, 1-5 days in transit
                                                depending on zone"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="First_Class_Mail_Tracking_1-3days"
                                                    defaultMessage="First Class Mail with Tracking
                                                1-3 Days"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Overnight_Next_Day_Delivery"
                                                    defaultMessage="Overnight, next day delivery"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Second_Day_Air"
                                                    defaultMessage="Second Day Air"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Overnight_Next_Day_Delivery_By_1030"
                                                    defaultMessage="Overnight, next day by 10:30"
                                                />
                                            </li>
                                        </ul>
                                        <p>
                                            <strong>
                                                <FormattedMessage
                                                    id="Common_Supplies"
                                                    defaultMessage="Common Supplies"
                                                />
                                            </strong>{' '}
                                            <FormattedMessage
                                                id="delivery_options"
                                                defaultMessage="delivery options:"
                                            />
                                        </p>
                                        <ul className="ordered-list-sec">
                                            <li>
                                                <FormattedMessage
                                                    id="First_Class_Mail_Tracking_1-3days"
                                                    defaultMessage="First Class Mail with Tracking
                                                1-3 Days"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Ground_1-5_days_intransit_dep_on_zone"
                                                    defaultMessage="Ground, 1-5 days in transit
                                                depending on zone"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Overnight_Next_Day_Delivery"
                                                    defaultMessage="Overnight, next day delivery"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Second_Day_Air"
                                                    defaultMessage="Second Day Air"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Overnight_Next_Day_Delivery_By_1030"
                                                    defaultMessage="Overnight, next day by 10:30"
                                                />
                                            </li>
                                        </ul>
                                        <p>
                                            <strong>
                                                <FormattedMessage
                                                    id="Repairs_Remakes_Loss_Damage"
                                                    defaultMessage="Repairs, Remakes, and Loss &amp;
                                                Damage Claims"
                                                />
                                            </strong>{' '}
                                            <FormattedMessage
                                                id="delivery_options"
                                                defaultMessage="delivery options:"
                                            />
                                        </p>
                                        <ul className="ordered-list-sec">
                                            <li>
                                                <FormattedMessage
                                                    id="Overnight_Next_Day_Delivery"
                                                    defaultMessage="Overnight, next day delivery"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Second_Day_Air"
                                                    defaultMessage="Second Day Air"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Overnight_Next_Day_Delivery_By_1030"
                                                    defaultMessage="Overnight, next day by 10:30"
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <h2 className="blue-text">
                            <FormattedMessage
                                id="Resources"
                                defaultMessage="Resources"
                            />
                        </h2>
                        <ul className="link-list-block">
                            {session !== null &&
                                session.country === 'US' &&
                                ['starkey', 'audibel'].includes(
                                    session.selectedBrand.toLowerCase()
                                ) && (
                                    <li>
                                        <a href="https://cdn.mediavalet.com/usil/starkeyhearingtech/oZEWwNLJzUeg9UvDUuNwzw/Ench_uuia0uY8tRq0vg_Qw/Original/eStore%20Ordering%20Instructions.pdf">
                                            <FormattedMessage
                                                id="eStore_User_Guide"
                                                defaultMessage="eStore User Guide"
                                            />
                                        </a>
                                    </li>
                                )}
                            <li>
                                <a href="/my-account/online-forms/service-request/repair">
                                    <FormattedMessage
                                        id="Repair_Return_or_Exchange_Center"
                                        defaultMessage="Repair, Return or Exchange Center"
                                    />
                                </a>
                            </li>
                            {![KR, DE].includes(session!.country) && (
                                <li>
                                    <a href="/my-account/online-forms/warranty-center">
                                        <FormattedMessage
                                            id="Visit_the_Warranty_Center"
                                            defaultMessage="Visit the Warranty Center"
                                        />
                                    </a>
                                </li>
                            )}
                            <li>
                                <a href="/my-account/online-forms/loss-damage-claim">
                                    <FormattedMessage
                                        id="Submit_Loss_or_Damaged_Claim"
                                        defaultMessage="Submit Loss or Damaged Claim"
                                    />
                                </a>
                            </li>
                            <li>
                                <a href="/my-account/hearing-aid-history">
                                    <FormattedMessage
                                        id="View_my_Device_Scan_History"
                                        defaultMessage="View my Device &amp; Scan History"
                                    />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="masthead">
                    <div className="masthead-inner text-center">
                        <h2 className="h1 white-text">
                            <FormattedMessage
                                id="Still_need_help"
                                defaultMessage="Still need help?"
                            />
                        </h2>
                        {
                            <a
                                href={getContactUsLink(session!)} // help center link doesn't begin with "order" or "local-order"
                                target="_blank"
                                rel="noreferrer noopener"
                                className="btn-primary"
                            >
                                <FormattedMessage
                                    id="Contact_Us"
                                    defaultMessage="Contact Us"
                                />
                            </a>
                        }
                    </div>
                </div>
            </main>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        session: state.session ? state.session.data! : null,
    };
};

const mapDispatchToProps = {};

const helpCenterContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(HelpCenter);

export default helpCenterContainer;
